import { useState } from "react";
import { Zap } from "lucide-react";

export const Logo = ({ className = "h-7" }) => {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return (
      <span className="flex items-center gap-2 text-paper">
        <span className="grid h-8 w-8 place-items-center bg-pink text-ink">
          <Zap size={16} strokeWidth={2.5} />
        </span>
        <span className="font-display text-lg font-semibold tracking-tight">
          Electra<span className="text-pink"> HR</span>
        </span>
      </span>
    );
  }
  return (
    <img
      src="/images/electra-hr-logo.png"
      alt="Electra HR"
      className={`${className} w-auto`}
      onError={() => setFailed(true)}
    />
  );
};

export const BrandImage = ({ src, fallback, alt, className = "", loading = "lazy", srcSet, sizes, fetchPriority }) => {
  const [err, setErr] = useState(false);
  return (
    <img
      src={err ? fallback : src}
      srcSet={err ? undefined : srcSet}
      sizes={err ? undefined : sizes}
      alt={alt}
      loading={loading}
      fetchPriority={fetchPriority}
      className={className}
      onError={() => setErr(true)}
    />
  );
};
